export const RouteConfig = {
  main: '/',
  signIn: '/signin',
  passwordReset: '/signin/password-reset',
  signUp: '/signin/signup',
  initialSetup: '/configuracao',
};
